import { AbilityBuilder, AbilityClass, PureAbility } from '@casl/ability'

import { User } from 'features/user'
import { product } from './abilities/product'
import { userByGroup } from './abilities/userByGroup'
import { userByRole } from './abilities/userByRole'
import { userByWorkspaceRole } from './abilities/userByWorkspaceRole'
import { Ability } from './types/ability'

export const abilityBuilder = (user: null | User): Ability => {
  const { build, can } = new AbilityBuilder(PureAbility as AbilityClass<Ability>)

  if (user) {
    userByGroup(user, can)
    userByRole(user, can)
    userByWorkspaceRole(user, can)
    product(user, can)
  }

  return build()
}
